import React from "react";
import Dashboard from "../Dashboard/Dashboard";
import SupportTicketSection from "../../Sections/SupportTicket";

const SupportTicketComponent = () => {
    return (
        <Dashboard sectionName={<SupportTicketSection />}/>
    );
};

export default SupportTicketComponent;
